import { Component, input, model } from '@angular/core';
import { NgClass } from '@angular/common';
import { ButtonComponent } from '@mwe/ui/components';

@Component({
  selector: 'lib-ikp-info-card-chevron-button',
  standalone: true,
  imports: [NgClass, ButtonComponent],
  templateUrl: './info-card-chevron-button.component.html',
  styles: ['.btn { height: 2.5rem; width: 2.5rem }', '.fas { color: white }'],
})
export class InfoCardChevronButtonComponent {
  isCollapsed = model<boolean>();
  index = input<number>();
  dataTest = input<string>();
  size = input<'lg' | 'md' | 'sm' | 'xs'>('md');
}
